import React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

function ArrowDownBoxIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M3 5a2 2 0 0 1 2-2h14c1.104 0 2 .896 2 2v14c0 1.104-.896 2-2 2H5a2 2 0 0 1-2-2V5zm8 1v8.51l-3.505-3.505L6.08 12.42 12 18.34l5.92-5.92-1.415-1.414L13 14.51V6h-2z" />
    </SvgIcon>
  );
}

export default ArrowDownBoxIcon;
